import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchWarrantyTasksCodesList = () => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/warranties/tasks-codes',
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_WARRANTY_TASK_CODES_LIST,
        ActionTypes.FETCHED_WARRANTY_TASK_CODES_LIST,
        [
          ActionTypes.FETCHED_WARRANTY_TASK_CODES_LIST_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const fetchWarrantyTaskCode = (code) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/warranties/tasks-codes/${code}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_WARRANTY_TASK_CODE,
        ActionTypes.FETCHED_WARRANTY_TASK_CODE,
        [
          ActionTypes.FETCHED_WARRANTY_TASK_CODE_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const addWarrantyTaskCode =
  (data = {}) =>
    (dispatch) => {
      return dispatch(
        apiActionCreator({
          'endpoint': '/warranties/tasks-codes',
          'authenticated': true,
          'types': [
            ActionTypes.ADDING_WARRANTY_TASK_CODE,
            [
              ActionTypes.ADDED_WARRANTY_TASK_CODE,
              MessageActions.addMessageBoxInfo(
                'Tarea creada satisfactoriamente'
              ),
            ],
            [
              ActionTypes.ADDED_WARRANTY_TASK_CODE_FAILED,
              (error) => buildErrorMessage(error),
            ],
          ],
          'microservice': 'part',
          'method': 'POST',
          'contentType': 'application/json',
          'data': data,
        })
      );
    };

export const updateWarrantyTaskCode =
  (code, data = {}) =>
    (dispatch) => {
      return dispatch(
        apiActionCreator({
          'endpoint': `/warranties/tasks-codes/${code}`,
          'authenticated': true,
          'types': [
            ActionTypes.UPDATING_WARRANTY_TASK_CODE,
            [
              ActionTypes.UPDATED_WARRANTY_TASK_CODE,
              MessageActions.addMessageBoxInfo(
                'Tarea actualizada satisfactoriamente'
              ),
            ],
            [
              ActionTypes.UPDATED_WARRANTY_TASK_CODE_FAILED,
              (error) => buildErrorMessage(error),
            ],
          ],
          'microservice': 'part',
          'method': 'PUT',
          'contentType': 'application/json',
          'data': data,
        })
      );
    };

export const clearWarrantyTasksCodes = () => ({
  'type': ActionTypes.CLEAR_WARRANTY_TASK_CODES_LIST,
});
